import { render, staticRenderFns } from "./AssetPoolDistribution.vue?vue&type=template&id=5b312528&scoped=true"
import script from "./AssetPoolDistribution.vue?vue&type=script&lang=js"
export * from "./AssetPoolDistribution.vue?vue&type=script&lang=js"
import style0 from "./AssetPoolDistribution.vue?vue&type=style&index=0&id=5b312528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b312528",
  null
  
)

export default component.exports